export default __webpack_public_path__ + "static/media/seven_lc2.ad0af080.png";